import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingbarService {
  private loadingBarSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  constructor() { }

  fetchLoadingBar(): Observable<boolean> {
    return this.loadingBarSubject.asObservable();
  }

  // Method to update the state of the loading bar
  updateLoadingBar(state: boolean): void {
    this.loadingBarSubject.next(state);
  }
}
